import * as React from 'react';
import SamsungPayBox from '../../components/common/SamsungPayBox';
import i18n, { changeLanguage } from 'i18next';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getSupportedLanguages } from '../../utils/getLanguage';
import styles from '../../css/pc/PcGeneral.module.css';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

export default function LanguagePage() {
  const navigate = useNavigate();

  const {t} = useTranslation();
  const [languageCode, setLanguageCode] = useState(i18n.language);
  const supportedLanguages = getSupportedLanguages();

  const handleCancelClick = () => {
    navigate('/gsmpi-web/binding');
  };

  const handleChangeLanguageClick = () => {
    changeLanguage(languageCode).then(() => {
      navigate('/gsmpi-web/binding');
    });
  };

  const handleItemClick = (event, item) => {
    setLanguageCode(item.code);
  };

  return (
    <>
      <SamsungPayBox>
        <div className="mpi-boxtop">
          <h1 className={`${cx('mpi-title')} ${cx('prevpage')}`}>{t('pay.gsmpi.changeRegion.msg1')}</h1>
        </div>
        <div className="mpi-content mpi-step-changeregion">
          <div className="mpi-region">
            <ul className="mpi-region-list">
              {supportedLanguages.map((item) => (
                <li key={item.code}>
                  <a className={languageCode === item.code ? "active" : ""} href="#" onClick={(event) => handleItemClick(event, item)}>
                    <span className="mpi-region-name">{item.name}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="mpi-boxbottom">
          <div className="mpi-button is-clearfix">
            <button type="button" className="mpi-button-cancel" onClick={handleCancelClick}>
              {t('pay.gsmpi.main.button1')}
            </button>
            <button type="button" className="mpi-button-submit" onClick={handleChangeLanguageClick}>
              {t('pay.gsmpi.changeRegion.button2')}
            </button>
          </div>
        </div>
      </SamsungPayBox>
    </>
  );
}